import React, { Component } from 'react'
import { connect } from 'react-redux'
import { showDialog } from '../redux/actions/MainDialog'
import { toggleLoginDialog } from '../redux/actions/authActions'
import { push } from '../components/routerPatch'

class GlobalContainer extends Component {
    showMessageDialog = (title, content) => {
        const {dispatch} = this.props

        dispatch(showDialog(title, content))
    }

    showLoginDialog = (section = 'signIn') => {
        const {dispatch} = this.props
        dispatch(toggleLoginDialog(true, section))
    }

    changeUrl = (newRoute) => {    
        const { dispatch } = this.props
        dispatch(push(newRoute));
    }

    render() {
        const { isAuthed, isAdmin, isJHAdmin, match, loginChecked } = this.props

        return (
            <>
                {loginChecked&&<>
                    {React.cloneElement(this.props.children, { 
                        showMessageDialog: this.showMessageDialog, 
                        showLoginDialog: this.showLoginDialog,
                        changeUrl: this.changeUrl, 
                        isAuthed, isAdmin, isJHAdmin, match })}
                </>}
            </>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo, loginChecked} = state.authUser;

    const isAdmin = (userInfo && userInfo.isAdmin)
    const isJHAdmin = (userInfo && userInfo.isJHAdmin)

    return {
        isAuthed, isAdmin, isJHAdmin, loginChecked
    }
}

export default connect(mapStateToProps)(GlobalContainer)